import Vue from 'vue'
import App from './App.vue'
import { Button,Icon,Dialog} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(VueLazyload)
new Vue({
  render: h => h(App),
}).$mount('#app')
